const t = new URL("../../../assets/icon-empty-BbqyaY9q.svg", import.meta.url).href;
export {
  t as default
};
//# sourceMappingURL=icon-empty.svg.js.map
